import CcIcons from '../../../../../common/ecommerce/common/CcIcons'

export default CcIcons
